<template>
  <div style='display: inline'>
    <StatusAvatar v-if="user" :user="user" avatar-size="36px" badge-size="12px" class="mr-4"/>
    <v-avatar v-if="!user && room.avatar" size="36" class="mr-4">
      <img
      :src="room.avatar"
      :alt="room.roomName">
    </v-avatar>
    <v-icon :color="room.roomColor" v-if="!user && !room.avatar" class="mr-4" large>
      {{ room.roomIcon }}
    </v-icon>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StatusAvatar from '@/components/buddies/status_avatar'

export default {
  name: 'chat-room-avatar',
  props: {
    room: { type: Object, default () {} }
  },
  components: { StatusAvatar },
  computed: {
    ...mapGetters({
      panelUsers: 'users/listAll',
      buddies: 'users/buddies'
    }),

    user () {
      return this.chatUserToPanelUser(this.room)
    }
  },
  methods: {
    chatUserToPanelUser (room) {
      const buddyUser = this.buddies.find((user) => user.exten === room.extension)
      if (buddyUser) {
        return buddyUser
      }
      if (room.extension) {
        return this.panelUsers.find((user) => user.exten === room.extension)
      }
      return null
    }
  }
}
</script>

<style>
</style>
